import { render, staticRenderFns } from "./CarDetails.vue?vue&type=template&id=db9cc052&"
import script from "./CarDetails.vue?vue&type=script&lang=js&"
export * from "./CarDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports